import 'element-closest-polyfill';

export const remove = (ele) => ele.classList.remove('is-open');
export const toggle = (ele) => ele.classList.toggle('is-open');
export const add = (ele) => ele.classList.add('is-open');

const handleClose = (target) => {
  const modal = document.querySelector(target.dataset.close);

  if (!modal) {
    return;
  }

  remove(modal);
};

const handleOpen = (target) => {
  const modal = document.querySelector(target.dataset.open);

  if (!modal) {
    return;
  }

  add(modal);
};

const handleToggle = (target) => {
  const modal = document.querySelector(target.dataset.modal);

  if (!modal) {
    return;
  }

  toggle(modal);
};

const onClickHandler = (event) => {
  let target = event.target.closest('[data-modal]');
  if (target) {
    handleToggle(target);
    return;
  }

  target = event.target.closest('[data-close]');

  if (target) {
    handleClose(target);
    return;
  }

  target = event.target.closest('[data-open]');

  if (target) {
    handleOpen(target);
    return;
  }

  target = event.target.closest('.formModal.is-open');

  if (target === event.target || (target && event.target.classList.contains('grid'))) {
    remove(target);
  }
};

const setupEvents = () => {
  document.documentElement.addEventListener('click', onClickHandler);
};

export default setupEvents;
